import { render, staticRenderFns } from "./ttshop_details.vue?vue&type=template&id=61680508"
import script from "./ttshop_details.vue?vue&type=script&lang=js"
export * from "./ttshop_details.vue?vue&type=script&lang=js"
import style0 from "./ttshop_details.vue?vue&type=style&index=0&id=61680508&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports